import { Box, Button, HStack, Text, useClipboard } from "@chakra-ui/react";
import { FiCopy, FiCheck } from "react-icons/fi";
import { BaseBlockProps } from "./types";

export const CodeBlock = ({ block }: BaseBlockProps) => {
  const code = block.code || block.content || "";
  const language = block.language || "plaintext";
  const { hasCopied, onCopy } = useClipboard(code);

  return (
    <Box
      borderRadius="component.lg"
      overflow="hidden"
      border="1px solid"
      borderColor="border.default"
    >
      <HStack
        justify="space-between"
        px="md"
        py="xs"
        bg="bg.section"
        borderBottom="1px solid"
        borderColor="border.default"
      >
        <Text fontSize="xs" color="text.body.tertiary" fontFamily="mono">
          {language}
        </Text>
        <Button
          size="xs"
          variant="ghost"
          leftIcon={hasCopied ? <FiCheck /> : <FiCopy />}
          onClick={onCopy}
          color="text.body.tertiary"
        >
          {hasCopied ? "Copied" : "Copy"}
        </Button>
      </HStack>
      <Box
        as="pre"
        p="md"
        bg="neutral.950"
        color="neutral.50"
        fontSize="sm"
        fontFamily="mono"
        overflowX="auto"
        whiteSpace="pre-wrap"
        wordBreak="break-word"
      >
        <code>{code}</code>
      </Box>
    </Box>
  );
};
